import { Id } from 'types/definitions'

/**
 * Links to other entities related to a document.
 */
export interface DocumentLinks {
  readonly job: {
    readonly jobIds: Id[]
  }
  readonly workRequest: {
    readonly workRequestId: Id | null
  }
  readonly strategy: {
    readonly folderId: Id | null
  }
}

/**
 * Links for a document.
 */
export const DocumentLinks = {
  empty: {
    job: { jobIds: [] },
    workRequest: { workRequestId: null },
    strategy: { folderId: null },
  } satisfies DocumentLinks,
}

/**
 * A link between a document and a job.
 */
export interface JobDocumentLinkInput {
  readonly type: 'Job'
  readonly jobId: Id
}

/**
 * A single link on a document.
 */
export type DocumentLinkInput = JobDocumentLinkInput
